"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { getStoredAuthSession, type AuthSession } from "@/shared/auth/session";
import { useLanguage } from "@/shared/hooks/use-language";
import { useRegionStore } from "@/shared/model/region-store";
import { trackAnalyticsEvent, type AnalyticsEventName, type AnalyticsProperties } from "./events";
export function useAnalytics() {
  const $ = _c(15);
  const [session, setSession] = React.useState(null);
  const [route, setRoute] = React.useState("/");
  const {
    language
  } = useLanguage();
  const region = useRegionStore(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setSession(getStoredAuthSession());
      setRoute(window.location.pathname || "/");
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  React.useEffect(t0, t1);
  const user = session?.user ?? null;
  const isAuthenticated = Boolean(user?.id);
  user?.id;
  user?.is_admin;
  user?.org_role;
  user?.organization_id;
  const t2 = user?.id == null ? null : String(user.id);
  const t3 = user?.organization_id ?? null;
  const t4 = user?.org_role ?? null;
  const t5 = user?.is_admin ?? false;
  const t6 = isAuthenticated ? "authenticated" : "anonymous";
  let t7;
  if ($[2] !== language || $[3] !== region || $[4] !== route || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
    t7 = {
      user_id: t2,
      organization_id: t3,
      org_role: t4,
      is_admin: t5,
      language,
      region,
      route,
      auth_state: t6
    };
    $[2] = language;
    $[3] = region;
    $[4] = route;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const commonContext = t7;
  let t8;
  if ($[11] !== commonContext) {
    t8 = (name, t9) => {
      const props = t9 === undefined ? {} : t9;
      trackAnalyticsEvent(name, {
        ...commonContext,
        ...props
      });
    };
    $[11] = commonContext;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const trackEvent = t8;
  let t9;
  if ($[13] !== trackEvent) {
    t9 = {
      trackEvent
    };
    $[13] = trackEvent;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}
function _temp(s) {
  return s.selectedRegion;
}